// extracted by mini-css-extract-plugin
export default {"termsWrapper":"Terms_termsWrapper__mCRMK","listHeader":"Terms_listHeader__YbSwW"};